import Loader from './loader';

export default class Logout {
    constructor($trigger) {
        this.loader = (new Loader(document.querySelector('[data-loader]')));

        this.logout = this.logout.bind(this);
        this.fetch = this.fetch.bind(this);

        $trigger.addEventListener('click', this.logout);
    }

    async logout() {
        this.loader.loading(true);

        await this.fetch();

        location.href = placeholders.baseUri;
    }

    async fetch() {


        try {
            const request = await fetch(
                    placeholders.baseUri
                        ? placeholders.baseUri + '/ajax-data/account/logout'
                        : 'ajax-data/account/logout',
                    {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        }
                    }
            );
            const result = await request.json();
            return result;
        } catch (e) {
            console.log(e);
        }
    }
}